import { Injectable } from '@angular/core';
import { CurrencyPipe, PercentPipe} from '@angular/common';
import { AuthenticationService } from './services/AuthenticationService';
import { MoovStep } from './models/moovStep';
import { MoovService } from './services/MoovService';
import { FileDefinitionService } from './services/FileDefinitionService';
import { map, Observable, of, take } from 'rxjs';
import { OutputFieldReference } from './models/outputFieldReference';
import { TimeZone } from './models/timeZone';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  public presetSearchFields!: any;
  public userTimeZone!: TimeZone;
  public supportedTimeZones!: TimeZone[];

  constructor(private authService:AuthenticationService, private moovService:MoovService, private fdService:FileDefinitionService, private currencyPipe:CurrencyPipe, private percentPipe:PercentPipe) { 
    this.moovService.getTimeZoneById(Intl.DateTimeFormat().resolvedOptions().timeZone).pipe(take(1)).subscribe(r=>{
      this.userTimeZone=r;
    });
    this.moovService.getSupportedTimeZones().pipe(take(1)).subscribe(r=>{
      this.supportedTimeZones=r;
    });
  }

  public init(){
    this.authService.init();
  }

  get authorized(){
    return this.authService.authorizedSubject.value;
  }
 
  get authenticated(){
    return this.authService.currentUserValue?true:false;
  }

  get currentUser(){
    return this.authService.currentUserValue;
  }

  get sftpHelpURL(){
    return 'https://detamoov.happyfox.com/kb/article/28-sftp-maintenance/';
  }

  get emailHelpURL(){
    return 'https://detamoov.happyfox.com/kb/article/63-email-processing-functionality/';
  }

  get genericAppSenderEmail(){
    return 'no-reply@detamoov.com';
  }

  public paginator(items: any, page?: any, perPage?: any) {
    page = page || 1;
    perPage = perPage || 4;
    var offset = (page - 1) * perPage; 
    var paginatedItems = items.slice(offset).slice(0, perPage);
    var totalPages = Math.ceil(items.length / perPage);
    return {
      data: paginatedItems,
      pagination:{
        page: page,
        perPage: perPage,
        prePage: page - 1 ? page - 1 : null,
        nextPage: (totalPages > page) ? page + 1 : null,
        total: items.length,
        totalPages: totalPages,
      }
    }
  }
  public static inputDefinitionTypeArray = [{id:0, name:'File Definition'}, {id:1, name:'Transformation Definition'}];
  public static availableReportArray=[{reportName: 'Activity Log', reportDescription: 'View all data received', routerPath:'activity-log', customer:true, superAdmin:true}, 
                              {reportName: 'moov Execution Log', reportDescription: 'View moov execution history', routerPath:'moov-execution-log', customer:true, superAdmin:true},
                              {reportName: 'moov Configuration Status Log', reportDescription: 'View all configured moovs by status', routerPath: 'moov-configuration-status-log', customer:true, superAdmin:true},
                              {reportName: 'Premier Integration Execution Log', reportDescription: 'View the premier integration execution history', routerPath:'premier-integration-execution-log', superAdmin:false, premierPartner:true},
                              {reportName: 'Scheduled Premier Integrations', reportDescription: 'View scheduled premier integrations', routerPath:'scheduled-premier-services', superAdmin:false, premierPartner:true},
                              {reportName: 'Billing Events', reportDescription: 'View all billing events', routerPath:'billing-events-log', customer:true, vendor:true, superAdmin:true},
                              {reportName: 'User List', reportDescription: 'List of all users', routerPath:'user-list', customer:false, vendor:false, superAdmin:true},
                            ];

  public static dataTypeArray= ['STRING','NUMERIC','DATE']; //['STRING','NUMERIC','DATE','BOOLEAN'];
  public static dataPatternArrayDate=['M/d/yyyy','M/d/yyyy hh:mm:ss','M/d/yyyy hh:mm:ss tt','M/d/yyyy hh:mm','M/d/yyyy hh:mm tt','M/d/yyyy h:mm:ss','M/d/yyyy h:mm:ss tt','M/d/yyyy h:mm','M/d/yyyy h:mm tt','M/d/yyyy HH:mm:ss','M/d/yyyy HH:mm','M/d/yyyy H:mm:ss','M/d/yyyy H:mm',
                                'M/d/yy','M/d/yy hh:mm:ss','M/d/yy hh:mm:ss tt','M/d/yy hh:mm','M/d/yy hh:mm tt','M/d/yy h:mm:ss','M/d/yy h:mm:ss tt','M/d/yy h:mm','M/d/yy h:mm tt','M/d/yy HH:mm:ss','M/d/yy HH:mm','M/d/yy H:mm:ss','M/d/yy H:mm',
                                'MM/dd/yyyy','MM/dd/yyyy hh:mm:ss','MM/dd/yyyy hh:mm:ss tt','MM/dd/yyyy hh:mm','MM/dd/yyyy hh:mm tt','MM/dd/yyyy h:mm:ss','MM/dd/yyyy h:mm:ss tt','MM/dd/yyyy h:mm','MM/dd/yyyy h:mm tt','MM/dd/yyyy HH:mm:ss','MM/dd/yyyy HH:mm','MM/dd/yyyy H:mm:ss','MM/dd/yyyy H:mm',
                                'MM/dd/yy','MM/dd/yy hh:mm:ss','MM/dd/yy hh:mm:ss tt','MM/dd/yy hh:mm','MM/dd/yy hh:mm tt','MM/dd/yy h:mm:ss','MM/dd/yy h:mm:ss tt','MM/dd/yy h:mm','MM/dd/yy h:mm tt','MM/dd/yy HH:mm:ss','MM/dd/yy HH:mm','MM/dd/yy H:mm:ss','MM/dd/yy H:mm',
                                'yyyy-MM-dd','yyyy-MM-dd hh:mm:ss','yyyy-MM-dd hh:mm:ss tt','yyyy-MM-dd hh:mm','yyyy-MM-dd hh:mm tt','yyyy-MM-dd h:mm:ss','yyyy-MM-dd h:mm:ss tt','yyyy-MM-dd h:mm','yyyy-MM-dd h:mm tt','yyyy-MM-dd HH:mm:ss','yyyy-MM-dd HH:mm','yyyy-MM-dd H:mm:ss','yyyy-MM-dd H:mm',
                                'yyyy-MM-ddTHH:mm:ssK',
                                'MM-dd-yyyy','MM-dd-yyyy hh:mm:ss','MM-dd-yyyy hh:mm:ss tt','MM-dd-yyyy hh:mm','MM-dd-yyyy hh:mm tt','MM-dd-yyyy h:mm:ss','MM-dd-yyyy h:mm:ss tt','MM-dd-yyyy h:mm','MM-dd-yyyy h:mm tt','MM-dd-yyyy HH:mm:ss','MM-dd-yyyy HH:mm','MM-dd-yyyy H:mm:ss','MM-dd-yyyy H:mm',
                                'yyyyMMdd','yyyyMMddHHmmss','yyyyMMddHHmm','yyyyMMddhhmmss','yyyyMMddhhmm',
                                'MMddyyyy','MMddyyyyHHmmss','MMddyyyyHHmm','MMddyyyyhhmmss','MMddyyyyhhmm',
                                'MMMM d yyyy', 'MMM d yyyy', 'MMMM d, yyyy', 'MMM d, yyyy',
                                'd-MMM-yy','d-MMM-yyyy','dd-MMM-yy', 'dd-MMM-yyyy',
                                'hh:mm:ss','hh:mm:ss tt','hh:mm','hh:mm tt','h:mm:ss','h:mm:ss tt','h:mm','h:mm tt','h:mmtt','hhmmss','hhmmssf','hhmmssff','hhmmssfff','HH:mm:ss','HH:mm','H:mm:ss','H:mm','HHmmss','HHmmssf','HHmmssff','HHmmssfff',
                                'yyyyDDD', 'yyDDD',
                                'yy.MM.dd','yyyy.MM.dd','MM.dd.yy','MM.dd.yyyy','yy.M.d', 'yyyy.M.d', 'M.d.yyyy', 'M.d.yy'
                              ];
  public static delayByArray=[{label:"no delay", value:0}, {label:"15min", value:15}, {label:"30min", value:30}, {label:"1hr", value:60}, {label:"2hrs", value:120}, {label:"4hrs", value:240}, {label:"8hrs", value:480},
                      {label:"12hrs", value:720}, {label:"24hrs", value:1440}, {label:"36hrs", value:2160}, {label:"48hrs", value:2880}, {label:"60hrs", value:3600}, {label:"72hrs", value:4320},
                      {label:"84hrs", value:5040}, {label:"96hrs", value:5760}, {label:"108hrs", value:6480}, {label:"120hrs", value:7200}];
  public static fileNamingComponentTypeArray=[{id:1, label:'DATETIME', inputType:'sel'},{id:2, label:'UNIQUE ID', inputType:undefined},{id:3, label:'TEXT', inputType:'slt'},{id:4, label:'DATA', inputType:'sel'},{id:5, label:'VARIABLE', inputType:'sel'},{id:6, label:'CUSTOM FIELD', inputType:'sel'}];
  public static fileNamingDateTimePatternArray=['yyyyMMdd', 'yyyyMMddHHmmss', 'yyMMdd', 'MMddyyyy', 'MMddyy', 'MMddyyyyhhmmss', 'yyyy-MM-dd', 'MM-dd-yyyy', 'hhmmss','hhmmssf','hhmmssff','hhmmssfff','HHmmss','HHmmssf','HHmmssff','HHmmssfff','yyyyDDD', 'yyDDD'];
  public static rowComponentTypeArray=[{id:1, label:'DATETIME', inputType:'sel'},{id:2, label:'UNIQUE ID', inputType:undefined},{id:3, label:'TEXT', inputType:'slt'},{id:5, label:'VARIABLE', inputType:'sel'},{id:6, label:'CUSTOM FIELD', inputType:'sel'}];
  public static rowDateTimePatternArray=['yyyyMMdd', 'yyyyMMddHHmmss', 'MMddyyyy', 'MMddyy', 'MMddyyyyhhmmss', 'yyyy-MM-dd', 'MM-dd-yyyy', 'HHmmss','yyyyMMdd-HHmmss','yyyyMMdd-hhmmss','yyyyDDD', 'yyDDD','UNIX'];
  public static usageTypeArray = [{ name: 'Per Execution', value: 0 }, { name: 'Unlimited Use', value: 1 }, { name: 'Unlimited Use Premium', value: 2 }, { name: 'Complimentary Use (Free)', value: 3 }, { name: 'Unlimited Use Custom', value: 4 }];
  public static integrationTypeArray = [{name:"Accounting/General Ledger", value:10}, {name:"Banking", value:20}, {name:"Benefits", value:30}, {name:"Employee", value:40}, {name:"Retirement - Payroll to Retirement", value:50}, {name:"Retirement - Retirement to Payroll", value:51}, {name:"Time Import", value:60}, {name:"Other", value:0}]
 
  public static receivedFileStatusArray = ['All', 'Processed', 'Error'];
  public static moovInstanceStatusArray = [{id:0, name:'Created'}, {id:1, name:'Processing'}, {id:2, name:'Completed'}, {id:3, name:'Failed'}, {id:4, name:'Deleted'}, {id:5, name:'Suspended'}];
  public static premierExecutionStatusArray = [{id:1, name:'In Process'}, {id:2, name:'Success'}, {id:3, name:'Error'}];
  public static premierExecutionScheduleOccurrenceArray = [{id:2,name:'Every "x" weeks'}, {id:3, name:'On certain days of the month'}];
  public static daysOfTheWeekArray = [{id:7, name:'Sunday'}, {id:1, name:'Monday'},{id:2, name:'Tuesday'}, {id:3, name:'Wednesday'}, {id:4, name:'Thursday'}, {id:5, name:'Friday'}, {id:6, name:'Saturday'}];
  public static reportingTimeFrameArray = ['Last 7 Days', 'Last 14 Days', 'Last 12 Months'];
  public static fileTypeArray = ['All', 'Input', 'Output'];

  public static validationSeverityArray = [{id:1, name:'Informational'},{id:2, name:'Warning'},{id:3, name:'Error'}];

  public static allocationMethodsArray = [{id:0, name:"Equal"}, {id:1, name:"Weighted"}];

  public static allocationFieldMethodsArray = [{id:0, name:"Sum"}, {id:1, name:"First"}, {id:2, name:"Max"}, {id:3, name:"Min"}];

  public static staticMetadataNames = ["moov-Current Dataset Name","moov-Original Dataset Name","moov-Client Name","moov-Configuration Status"];

  public static feeTypes = [{billingTypeCode:'mm', displayName:'Monthly Minimum'}];

  public static stateCodes = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY' ];

  public static moovStepSkipTypes = [{id:0, name:'NONE'},{id:1, name:'Skip if no data is present'}, {id:2, name:'Always skip'}];

  public static stateArray =
    [
      {
        "name": "Alabama",
        "code": "AL"
      },
      {
        "name": "Alaska",
        "code": "AK"
      },
      {
        "name": "American Samoa",
        "code": "AS"
      },
      {
        "name": "Arizona",
        "code": "AZ"
      },
      {
        "name": "Arkansas",
        "code": "AR"
      },
      {
        "name": "California",
        "code": "CA"
      },
      {
        "name": "Colorado",
        "code": "CO"
      },
      {
        "name": "Connecticut",
        "code": "CT"
      },
      {
        "name": "Delaware",
        "code": "DE"
      },
      {
        "name": "District Of Columbia",
        "code": "DC"
      },
      {
        "name": "Federated States Of Micronesia",
        "code": "FM"
      },
      {
        "name": "Florida",
        "code": "FL"
      },
      {
        "name": "Georgia",
        "code": "GA"
      },
      {
        "name": "Guam",
        "code": "GU"
      },
      {
        "name": "Hawaii",
        "code": "HI"
      },
      {
        "name": "Idaho",
        "code": "ID"
      },
      {
        "name": "Illinois",
        "code": "IL"
      },
      {
        "name": "Indiana",
        "code": "IN"
      },
      {
        "name": "Iowa",
        "code": "IA"
      },
      {
        "name": "Kansas",
        "code": "KS"
      },
      {
        "name": "Kentucky",
        "code": "KY"
      },
      {
        "name": "Louisiana",
        "code": "LA"
      },
      {
        "name": "Maine",
        "code": "ME"
      },
      {
        "name": "Marshall Islands",
        "code": "MH"
      },
      {
        "name": "Maryland",
        "code": "MD"
      },
      {
        "name": "Massachusetts",
        "code": "MA"
      },
      {
        "name": "Michigan",
        "code": "MI"
      },
      {
        "name": "Minnesota",
        "code": "MN"
      },
      {
        "name": "Mississippi",
        "code": "MS"
      },
      {
        "name": "Missouri",
        "code": "MO"
      },
      {
        "name": "Montana",
        "code": "MT"
      },
      {
        "name": "Nebraska",
        "code": "NE"
      },
      {
        "name": "Nevada",
        "code": "NV"
      },
      {
        "name": "New Hampshire",
        "code": "NH"
      },
      {
        "name": "New Jersey",
        "code": "NJ"
      },
      {
        "name": "New Mexico",
        "code": "NM"
      },
      {
        "name": "New York",
        "code": "NY"
      },
      {
        "name": "North Carolina",
        "code": "NC"
      },
      {
        "name": "North Dakota",
        "code": "ND"
      },
      {
        "name": "Northern Mariana Islands",
        "code": "MP"
      },
      {
        "name": "Ohio",
        "code": "OH"
      },
      {
        "name": "Oklahoma",
        "code": "OK"
      },
      {
        "name": "Oregon",
        "code": "OR"
      },
      {
        "name": "Palau",
        "code": "PW"
      },
      {
        "name": "Pennsylvania",
        "code": "PA"
      },
      {
        "name": "Puerto Rico",
        "code": "PR"
      },
      {
        "name": "Rhode Island",
        "code": "RI"
      },
      {
        "name": "South Carolina",
        "code": "SC"
      },
      {
        "name": "South Dakota",
        "code": "SD"
      },
      {
        "name": "Tennessee",
        "code": "TN"
      },
      {
        "name": "Texas",
        "code": "TX"
      },
      {
        "name": "Utah",
        "code": "UT"
      },
      {
        "name": "Vermont",
        "code": "VT"
      },
      {
        "name": "Virgin Islands",
        "code": "VI"
      },
      {
        "name": "Virginia",
        "code": "VA"
      },
      {
        "name": "Washington",
        "code": "WA"
      },
      {
        "name": "West Virginia",
        "code": "WV"
      },
      {
        "name": "Wisconsin",
        "code": "WI"
      },
      {
        "name": "Wyoming",
        "code": "WY"
      }
    ]

  public static integrationTags = [{id:1, name:'ConnectPayroll'}, {id:2, name:'Evolution'}, {id:3, name:'MPAY'}, {id:4, name:'ReadyPay'}]

  public static getPremierPartnerOptionalParameterListName(premierPartnerProviderName:string, premierServiceProductType:string){
    if(premierPartnerProviderName == "prismhr"){
      return "batchIdList";
    }
    else if(premierPartnerProviderName == "execupay"){
      return "payrollIdList";
    }
    else if(premierPartnerProviderName == "prismhcm" && (premierServiceProductType=="401K" || premierServiceProductType=="payroll")){
      return "payrollSummaryIdList";
    }
    else if(premierPartnerProviderName == "primepay_spay"){
      return "payProcessIdList";
    }
    else if(premierPartnerProviderName == "prosoftware"){
      return "payrollNumberList";
    }
    else if(premierPartnerProviderName == "isolved"){
      return "payrollRunNumberList";
    }
    else{
      return "idList";
    }
  }

  static get allPremierPartnerOptionalParameterListNames(){
    return ["batchIdList","payrollIdList","payrollSummaryIdList","payProcessIdList","payrollNumberList","idList","payrollRunNumberList"];
  }

  public getMoovStepType(code:string){
    switch(code){
      case "tr":
        return "Trigger - Data File received";
      case "qi":
        return "Trigger - QBO IIF File received";
      case "dt":
        return "Trigger - Document File received (no transfomation)";
      case "no":
        return "Action - Notify";
      case "tf":
        return "Action - Transform";
      case "en":
        return "Action - Encrypt";
      case "dc":
        return "Action - Decrypt";
      case "de":
        return "Action - Deliver SFTP";
      case "sf":
        return "Action - Send File";
      case "nf":
        return "Action - Name File";
      case "ff":
        return "Action - Filter";
      case "fc":
        return "Action - Consolidate";
      case "md":
        return "Action - Custom Fields";
      case "hr":
        return "Action - Header / Footer Rows";
      case "ed":
        return "Action - Edit Data";
      case "ii":
        return "Action - isolved Import";
      case "vf":
        return "Action - Validate File";
      case "ad":
        return "Action - Allocate Data";
      case "iq":
        return "Action - QBO Import";
      case "ft":
        return "Action - Deliver FTPS";
      case "qm":
        return "Action - Queue moov";
      case "up":
        return "Action - UKG Time Punch";
      case "ui":
        return "Action - UKG Import";
      case "xi":
        return "Action - Xero Import";
      case "du":
        return "Action - Dropbox Upload";
      case "msc":
        return "Action - Microsoft Calendar API";
      case "elpdat":
        return "Trigger - Live Payroll Report Data Trigger";
      case "elpdoc":
        return "Trigger - Live Payroll Report Document Trigger";
      case "st":
        return "Trigger - SFTP Pull Data Trigger";
      case "pi":
        return "Action - PrismHR Import";
      case "pedt":
        return "Action - PrismHCM Employee Export";
      case "ppdt":
        return "Action - PrismHCM Payroll Export";
      case "pgi":
          return "Action - PrismHCM Generic Import";
      case "pr360":
        return "Action - PrismHR Retirement 360";
      case "ur360":
        return "Action - UKG Retirement 360";
      case "rd":
        return "Action - Reset Data";
      case "psr360":
        return "Action - CoAd SPAY Retirement 360";
      case "pii":
        return "Action - Prepare isolved Import";
      case "peli":
        return "Action - Prepare isolved Employee Loans";
      case "pgr360":
        return "Action - CoAd GPAY Retirement 360";
      case "api":
        return "Action - API";
      case "cd":
        return "Action - Concatenate Data";
      case "wh":
        return "Trigger - Webhook Data Trigger";
      case "ai":
        return "Action - AI Agent";
      case "uzip":
        return "Action - Unzip File";
      case "af":
        return "Action - Apply File Definition";
      case "msapi":
        return "Action - Microsoft API";
      default:
        return '';
    }
  }

  public getMoovStepOutputParameters(ms:MoovStep):Observable<OutputFieldReference[]>{
    //currently only stepType tf produces output
    if(ms.moovStepDefinition.stepType=='tf'){
      //stepType tf produces output via the transformation definition. Protocols with a TD are flagged with 'isOutPutParameter=true'
      let defaultParameter = ms.defaultParameters.find(p=>p.name=="transformationDefinition");
      if(defaultParameter && defaultParameter.value){
        let tdId = parseInt(defaultParameter.value);
        if(!isNaN(tdId)){
          return this.fdService.getTransformationDefinitionById(false,tdId).pipe(take(1), map(td=>{
            let outputParameters:OutputFieldReference[]=[];
            if(td){
              td.transformationProtocols.forEach(tp=>{
                if(tp.isOutputParameter){
                  outputParameters.push(tp.outputFieldReference);
                }
              })
            }
            return outputParameters;
          }));
        }
        return of([]);
      }
        else return of([]);
      }
    else{
      return of([]);
    }
  }

  public getRecurrenceDescription(recurrenceType:number, recurrenceInterval:number, recurrenceHour:number, recurrenceMinute:number, recurrenceDays:number[]){
    let schedule:string = '';
    let days:string[]=[];
    let time= new Date(0,0,0,recurrenceHour,recurrenceMinute);
    switch(recurrenceType){
      case 0:
        schedule="None";
      case 2:
        let weeks=recurrenceInterval>1?' weeks':' week';
        recurrenceDays.forEach(d=>{days.push(' '+AppService.daysOfTheWeekArray.find(day=>day.id==d)!.name)});
        schedule = "Every "+recurrenceInterval+weeks+" on"+days.toString()+ " at "+time.toLocaleTimeString([], {hour:'numeric',minute:'2-digit'});
        break;
      case 3:
        recurrenceDays.forEach(d=>days.push(' '+this.ordinalSuffix(d)));
        schedule = "On the"+days.toString()+" of each month at "+time.toLocaleTimeString([], {hour:"numeric",minute:'2-digit'});
        break;
      default:
        break;
    }
    return schedule;
  }

  private ordinalSuffix(i:number){ //add ordinal suffix to days of the month
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
  }

  public moovConfigurationStatusArray=[{id:0,name:"Draft"}, {id:1,name:"Testing"}, {id:2,name:"Active"}, {id:3,name:"Inactive"}]
  public moovConfigurationFrequencyArray=[{id:0,name:"Daily"}, {id:1,name:"Weekly"}, {id:2,name:"Bi-Weekly"}, {id:3,name:"Semi-Monthly"}, {id:4,name:"Monthly"}]

  public transformAmount(value: any){
    var number;
    if(typeof value === 'string') number = this.numberFromString(value);
    else number=value;
    if(number && number!=null) return this.currencyPipe.transform(number);
    else return null;
  }
  public numberFromString(value:string){
    if(value){
      var str = value.replace(/[^0-9.-]+/g,"");
      if(str.length==0) return null;
      var n = Number(str);
      return Number.isNaN(n)?null:n;
    }
    else return null;
  }
  public transformAmountIfNumber(value: any){
    var result;
    if(typeof value === 'string') result = this.numberFromString(value);
    else result=value;
    if(result!=null) return this.currencyPipe.transform(result);
    else return value;
  }
  public transformPercent(value: any){
    var number;
    if(typeof value === 'string') number = this.numberFromString(value);
    else number=value;
    if(number && number!=null) return this.percentPipe.transform(number/100, '1.2-2');
    else return null;
  }
}
